
export default function includeNewRelic ( environment ) {
    if ( environment !== 'prod' ) {
        require( './utils/startup/new-relic-non-prod.js' );
    } else {
        require( './utils/startup/new-relic-prod.js' );
    }

}
